import React from 'react';
import { FileEdit, Trash2 } from 'lucide-react';
import { timeLabel } from '../../../lib/dateBuckets';
import { htmlToText } from '../../../lib/emailTemplates';

export const DraftsList = ({ drafts, onOpen, onDelete }) => (
  <div className="space-y-2" data-testid="drafts-list">
    {drafts.length === 0 && <p className="text-xs text-neutral-500 border border-dashed rounded-lg p-8 text-center">No drafts. Use "Save draft" in the composer to park a message here.</p>}
    {drafts.map((d) => (
      <div key={d.id} className="flex items-center gap-3 bg-white border rounded-xl px-3 py-2 hover:border-amber-300" data-testid={`draft-row-${d.id}`}>
        <FileEdit className="w-4 h-4 text-amber-600 shrink-0" />
        <button type="button" onClick={() => onOpen(d)} className="flex-1 min-w-0 text-left" data-testid={`draft-open-${d.id}`}>
          <p className="text-xs font-medium text-neutral-900 truncate">{d.subject || '(no subject)'} <span className="text-neutral-400 font-normal">· {d.to?.length ? d.to.join(', ') : 'no recipient'}</span></p>
          <p className="text-[11px] text-neutral-500 truncate">{htmlToText(d.html) || 'Empty message'}</p>
        </button>
        <span className="text-[10px] text-neutral-400 shrink-0">{timeLabel(d.updated_at)}</span>
        <button type="button" onClick={() => onDelete(d)} className="p-1.5 rounded hover:bg-red-50 text-neutral-400 hover:text-red-600" title="Delete draft" data-testid={`draft-delete-${d.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
      </div>
    ))}
  </div>
);

export default DraftsList;
